import { Component } from 'react';
import { B } from '../../constants/brand';
import { Icon } from '../ui';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 48, textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', color: B.red, marginBottom: 12 }}><Icon name="warning" size={36} strokeWidth={1.75} /></div>
          <div style={{ fontSize: 15, fontWeight: 700, color: B.red, marginBottom: 8 }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 13, color: B.textMd, marginBottom: 24, maxWidth: 400, margin: '0 auto 24px' }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              padding: '9px 20px', background: B.navy, color: '#fff',
              border: 'none', borderRadius: 6, cursor: 'pointer',
              fontFamily: 'inherit', fontSize: 13, fontWeight: 600,
            }}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
